// extracted by mini-css-extract-plugin
export default {"wrapper":"Yl1AFMpF5i4PdQI1FKfP","container":"fB52FtmHiMW1Cu2KkoH2"};